import {Component, OnInit, Input, Output, ViewChild, EventEmitter} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {DtoTreatmentList} from "./models/DtoTreatmentList";
import {DtoSubscriptionTypeUseTreatment} from "./models/DtoSubscriptionTypeUseTreatment";

@Component({
    selector: 'ngx-subscription-type-treatment',
    template: require('./subscription-type-treatment.component.html'),
    styles: [require('./subscription-type-treatment.component.css')]
})
@AutoUnsubscribe()

export class SubscriptionTypeTreatmentComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() allTreatments: DtoTreatmentList[];
    @Input() chosenTreatments: DtoSubscriptionTypeUseTreatment[];
    @Output() treatmentSaved = new EventEmitter<DtoSubscriptionTypeUseTreatment>();
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Nummer',
            type: 'number',
            width: '100'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        }
    ];

    ngOnInit() {
        let treatmentsToShow: DtoTreatmentList[] = [];
        for (let i = 0; i < this.allTreatments.length; i++) {
            if (!this.chosenTreatments.find(x => x.treatmentId == this.allTreatments[i].id)) {
                treatmentsToShow.push(this.allTreatments[i]);
            }
        }

        setTimeout(() => {
            this.grid.showData(treatmentsToShow);
        });
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        if (this.grid.getSelectedId() > 0) {
            let treatment = this.allTreatments.find(x => x.id == this.grid.getSelectedId());
            this.treatmentSaved.emit({
                id: 0,
                treatmentId: treatment.id,
                description: treatment.description,
                index: treatment.index
            });
            this.closeWindow(true);
        }
    }

    rowdoubleClicked(event) {
        this.btnSaveClicked(null);
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/subscription-type-treatment.component.ts